import { Container, Flex, Text, SimpleGrid, Box, Heading, Link, Stack, IconButton } from '@chakra-ui/react';
import { FaWhatsapp } from 'react-icons/fa'; // Importa el icono de WhatsApp
import { COLORS } from "../../colors";
import React from 'react';

const WhatsApp = () => {
  return (

      <Link
        href="https://api.whatsapp.com/send?phone=601129552"
        isExternal
        position="fixed"
        bottom="4"
        right="4"
        bg={COLORS.brand1}
        color="white"
        rounded="full"
        p={3}
        zIndex="tooltip"
        _hover={{
          bg: 'green.600',
        }}
      >
        <FaWhatsapp />
      </Link>

  );
};

export default WhatsApp;
